<template>
  <a
    v-if="whatsappNumber"
    :href="`https://wa.me/${whatsappNumber.replace(/\D/g, '')}`"
    target="_blank"
    rel="noopener"
    class="whatsapp-float"
    aria-label="WhatsApp"
  >
    <img src="@/assets/whatsapp-logo.png" alt="WhatsApp" class="whatsapp-img" />
  </a>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useSettingsStore } from '@/stores/settingsStore'

const settingsStore = useSettingsStore()

const whatsappNumber = computed(() => {
  return settingsStore.settings?.whatsapp_number || null
})

onMounted(() => {
  if (!settingsStore.settings && !settingsStore.loading) {
    settingsStore.fetchSettings()
  }
})
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  background: transparent;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: filter 0.2s;
  padding: 0;
}
.whatsapp-float:hover {
  filter: brightness(0.9);
  text-decoration: none;
}
.whatsapp-img {
  width: 48px;
  height: 48px;
  display: block;
}
</style> 